// extracted by mini-css-extract-plugin
export var divider = "_i9-7";
export var itemsToggle = "_i9-8";
export var mergeModal = "_i9-1";
export var optionCard = "_i9-4";
export var radioGroup = "_i9-6";
export var radioOption = "_i9-0";
export var selected = "_i9-5";
export var shipmentOptions = "_i9-2";
export var tableOptions = "_i9-3";